const routeRoutesUrls = {
  activeListing: `/routes/active-listing`,
  finishedListing: `/routes/finished-listing`,
};

export default routeRoutesUrls;
